import styled from '@emotion/styled';
import { bodyM, captionM, subTitle2, title2 } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

export const Background = styled.section`
  background: #e5eef7;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Wrapper = styled.div`
  max-width: 500px;
  padding: 80px 16px;
  align-self: stretch;
  background-color: #e5eef7;
  white-space: pre-line;
  width: 100%;
`;

export const Title = styled.span`
  ${title2};
  color: ${vars.neutral[100]};
`;

export const Text = styled.span`
  ${bodyM};
  color: ${vars.neutral[80]};
`;

export const SubTitle = styled.span`
  ${subTitle2};
  color: ${vars.neutral[90]};
  gap: 16px;
`;

export const SubText = styled.span`
  ${captionM};
  color: ${vars.neutral[70]};
  gap: 6px;
`;

export const ImageWrapper = styled.div`
  width: 281px;
  height: 140px;
  position: relative;
`;
